import { select } from 'modules/dom'

export default (el) => {
  const BUTTON_NEXT_MONTH = '.js-button-next-month'
  const BUTTON_NEXT_MONTH_CALENDAR = '.js-calendar-next'
  const buttonNextMonth = select(BUTTON_NEXT_MONTH, el)
  const buttonNextMonthCalendar = select(BUTTON_NEXT_MONTH_CALENDAR)
  if (buttonNextMonth && buttonNextMonthCalendar) {
    buttonNextMonth.addEventListener('click', (e) => {
      e.preventDefault()
      buttonNextMonthCalendar.click()
    })
  }
}
